import {createContext} from 'react';
import type {TShow} from '../../../hooks/useShow';

export interface BrandingTextEditorContext {
    currentEditorName?: string;
    setCurrentEditorName: (name?: string) => void;
}

export interface BrandingWhatsAppContext {
    message: string;
    setMessage: (message: string) => void;
    aiGeneratorShow: TShow;
}

export interface BrandingContextValue {
    textEditor: BrandingTextEditorContext;
    whatsapp?: BrandingWhatsAppContext;
}

export const BrandingContext = createContext<BrandingContextValue | null>(null);
